import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchPartOneVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPartOneVehicleInformation/patchPartOneVehicleInformationFunction';
import { PatchPartOneVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPartOneVehicleInformation/patchPartOneVehicleInformation.type';

export const PatchPartOneVehicleInformationOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchPartOneVehicleInformationType
> => ({
  mutationKey: ['patch-part_one-vehicle-information'],
  mutationFn: ({ id, data, damaged_id }: PatchPartOneVehicleInformationType) =>
    patchPartOneVehicleInformationFunction({ damaged_id, data, id }),
});
